import type { PipeTransform } from '@angular/core';
import { Injectable, Pipe } from '@angular/core';

import moment from 'moment-timezone';

@Pipe({
  name: 'rtDateFormatTimezone',
  standalone: true,
})
@Injectable({ providedIn: 'root' })
export class DateFormatTimezonePipe implements PipeTransform {
  public transform(date: string | Date, timezone: string, format?: string): string {
    return moment(date).tz(timezone).format(format);
  }
}
